import React from 'react';
import { useTranslation } from 'react-i18next';
import HoldingsTable from '../tables/HoldingsTable';

const PortfolioPage = ({ holdings, currentLanguage }) => {
  const { t } = useTranslation();

  return (
    <div className="content-section" key={`portfolio-section-${currentLanguage}`}>
      <h2>{t('portfolio.title')}</h2>
      <div className="portfolio-section">
        {holdings.length > 0 && (
          <HoldingsTable 
            holdings={holdings} 
            currentLanguage={currentLanguage} 
            key={`holdings-table-wrapper-${currentLanguage}`} 
          />
        )}
      </div>
    </div>
  );
};

export default PortfolioPage;
